
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>
  Das Coronavirus hält derzeit die Welt in Atem. Und die Grippewelle und Erkältungen wüten jedes Jahr aufs Neue. Dabei gibt es ein einfaches Mittel, viele der Erreger fernzuhalten: Händewaschen! Und zwar richtig. Doch das ist offenbar gar nicht so einfach.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;